/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';

type BusyStateContextProps = {
  /**
   * A function that adds busy state to the root element
   */
  addBusyState: (description: string) => () => void;
};

/**
 * Context which the parent custom element components can use for passing down
 * the busy context
 */
export const BusyStateContext = createContext<BusyStateContextProps>({
  addBusyState: () => () => {}
});
